// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7b0c1f3","239":"d1717163","453":"0ac5ab44","455":"0e78d828"}[chunkId] + ".chunk.js";
};